import React from 'react';

import Navigation, { AppContext } from '../components/Navigation';
import Home from '../views/Homepage';

export default function App(props) {
  return (
    <Navigation>
      <AppContext.Consumer>
        {(contextProps) => <Home {...props} {...contextProps} />}
      </AppContext.Consumer>
    </Navigation>
  );
}
